import React from 'react';
import { IconFill, IconProps } from './IconTemplate';

import { ReactComponent as Icon } from '@assets/icons/chevron-down.svg';

export default function ChevronDownIcon(props: IconProps) {
  return <IconFill icon={Icon} {...props} />;
}
